import { useEffect, useState } from 'react';
import { api, getSession } from '../api/client.ts';
import { semaineISO, nbSemainesISO, semaineDeDate } from '../../../shared/business-logic/semaines.ts';

export interface Choix { csbId: string; annee: number; semaine: number }
interface CsbLigne { id: string; nom: string }

/** Établissement (administrateur seulement) + année + semaine ISO, avec affichage explicite des dates de début et de fin. */
export default function SelecteurSemaine({ choix, onChange }: { choix: Choix; onChange: (c: Choix) => void }) {
  const session = getSession();
  const admin = session.role === 'ADMIN';
  const [csb, setCsb] = useState<CsbLigne[]>([]);
  useEffect(() => { if (admin) api.get<CsbLigne[]>('/admin/csb').then(setCsb).catch(() => setCsb([])); }, [admin]);
  const annees = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 4 + i);
  const max = nbSemainesISO(choix.annee);
  const s = semaineISO(choix.annee, Math.min(choix.semaine, max));
  return (
    <div className="carte" style={{ marginBottom: 12 }}>
      {admin && (
        <>
          <label htmlFor="sel-csb">Établissement</label>
          <select id="sel-csb" value={choix.csbId} onChange={(e) => onChange({ ...choix, csbId: e.target.value })}>
            <option value="">— choisir —</option>
            {csb.map((c) => <option key={c.id} value={c.id}>{c.nom}</option>)}
          </select>
        </>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <div><label htmlFor="sel-annee">Année</label>
          <select id="sel-annee" value={choix.annee} onChange={(e) => onChange({ ...choix, annee: Number(e.target.value), semaine: Math.min(choix.semaine, nbSemainesISO(Number(e.target.value))) })}>
            {annees.map((a) => <option key={a} value={a}>{a}</option>)}
          </select></div>
        <div><label htmlFor="sel-sem">Semaine</label>
          <select id="sel-sem" value={s.semaine} onChange={(e) => onChange({ ...choix, semaine: Number(e.target.value) })}>
            {Array.from({ length: max }, (_, i) => i + 1).map((n) => <option key={n} value={n}>S{n}</option>)}
          </select></div>
      </div>
      <p className="note" style={{ margin: '6px 0 0' }}>Semaine du lundi {s.debut.slice(8, 10)}/{s.debut.slice(5, 7)} au dimanche {s.fin.slice(8, 10)}/{s.fin.slice(5, 7)}/{s.fin.slice(0, 4)}</p>
    </div>
  );
}

/** Choix initial : établissement du compte, dernière semaine terminée. */
export function choixInitial(): Choix {
  const hier7 = new Date(Date.now() - 7 * 86_400_000);
  const d = `${hier7.getFullYear()}-${String(hier7.getMonth() + 1).padStart(2, '0')}-${String(hier7.getDate()).padStart(2, '0')}`;
  const { annee, semaine } = semaineDeDate(d);
  return { csbId: getSession().csbId ?? '', annee, semaine };
}
